import React, { useState, useEffect } from "react";

import { Button, Pane, Typography, Table } from "clearsense-ui/components";

import {
  ASSOCIATE_PEOPLE_COLUMNS,
  ASSOCIATE_PEOPLE_DATA,
} from "../../constants/associatePeople";

const AssociatePeople = ({
  businessGlossary,
  isPaneOpen,
  setIsPaneOpen = () => {},
}) => {
  const [selected, setSelected] = useState([]);
  const [rowData, setRowData] = useState(ASSOCIATE_PEOPLE_DATA);

  const addToSelected = item => {
    const itemIndex = selected.findIndex(each => each === item);
    if (itemIndex === -1) setSelected([...selected, item]);
    else {
      const selectedCopy = [...selected];
      selectedCopy.splice(itemIndex, 1);
      setSelected(selectedCopy);
    }
  };

  const addCheckToSelected = () => {
    setRowData(
      rowData
        .map(row =>
          selected.includes(row.id)
            ? { ...row, checked: true }
            : { ...row, checked: false }
        )
        .sort((a, b) => b.checked - a.checked || a.name.localeCompare(b.name))
    );
  };

  useEffect(() => addCheckToSelected(), [selected]);

  return (
    <Pane isOpen={isPaneOpen} onClose={() => setIsPaneOpen(false)} size="md">
      <Pane.Header>
        <Typography style="h3" type="bold" className="-mt-3">
          Associate People in {businessGlossary?.name}
        </Typography>
        <Typography style="large">Description</Typography>
      </Pane.Header>
      <Pane.Body className="py-8">
        <Table
          columnData={ASSOCIATE_PEOPLE_COLUMNS}
          rowData={rowData}
          allowRowClick
          onRowClick={(e, record) => addToSelected(record.id)}
          rowKey={row => row.id}
        />
      </Pane.Body>
      <Pane.Footer className="gap-4">
        <Button
          label="Save and Close"
          onClick={() => setIsPaneOpen(false)}
          disabled={selected.length === 0}
        />
        <Button
          label="Cancel"
          style="secondary"
          onClick={() => setIsPaneOpen(false)}
        />
      </Pane.Footer>
    </Pane>
  );
};

export default AssociatePeople;
